import { render } from "./FormCharacterCounter.vue?vue&type=template&id=9f83cd7c"
import script from "./FormCharacterCounter.vue?vue&type=script&lang=js"
export * from "./FormCharacterCounter.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__